import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './BigMenu.css';

export default class BigMenu extends Component {

	constructor(props){

		super(props);
		let data = {boxes: [],...props.data};
		this.state = {
			data: data,
			config: {config: [], ...props.config},
			length: data.boxes.length + data.boxes.filter((item) => item.hasOwnProperty('sub_menu')).reduce((a,b) => a + b.sub_menu.length, 0),
			width: 0,
			height: 0
		}
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

	}


	componentDidMount() {
  	this.updateWindowDimensions();
  	window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
	  window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions() {
  	this.setState({ width: window.innerWidth, height: window.innerHeight });
	}

	render() {
		if(this.state.width > 600){
			return (
				<div className="BigMenu col-xs-12 col-ms-12 col-lg-12">
					<div className="row">
						<div className="gb-parentpanel-hoder" >
							<div className="concurs-panels-holder panels-holder-desctopset">
								<div className="festivalpg-panelholder-mask" style={{backgroundColor: "#"+this.state.config.gbcolor}}></div>

									{this.state.data.boxes.map(function(object, i){

										if(typeof object.sub_menu !== "undefined" && object.sub_menu.constructor === Array){
											return (
													<div className="festivalpg-panelholder" key={object.id} style={{borderColor: object.color}}>
															{ object.sub_menu ? (
																<div className="festivalpg-panelbox">
																	<span className="festival-hover-mask"></span>
																	<div className="fest-hover-desc">
																		<p className="festivalpg-paneltitle">
																			{object.name}
																		</p>
																		<div className="festivalpg-paneldescriptoin">
																			<ul className="panel-menu-list">
																				{ object.sub_menu ? (
																						object.sub_menu.map(function(object1, a){
																							return (<li key={a}><Link to={object1.url}>{object1.name}</Link></li>);
																						})
																					):('')
																				}
																				</ul>
																			</div>
																		</div>
																	</div>
																):(
																	<Link to={object.url}>
																		<div className="festivalpg-panelbox">
																			<span className="festival-hover-mask"></span>
																			<div className="fest-hover-desc">
																				<p className="festivalpg-paneltitle">
																					{object.name}
																				</p>
																				<div className="festivalpg-paneldescriptoin">
																					<ul className="panel-menu-list">
																						{ object.sub_menu ? (
														 										object.sub_menu.map(function(object1, a){
																									return (<li key={a}><Link to={object1.url}>{object1.name}</Link></li>);
																								})
																							):('')
																						}
																					</ul>
																				</div>
																			</div>
																		</div>
																	</Link>
																)
															}
													</div>
													);
										}else{
											return (
													<div className="festivalpg-panelholder" key={object.id} style={{borderColor: object.color}}>
															{ object.sub_menu ? (
																<div className="festivalpg-panelbox">
																	<span className="festival-hover-mask"></span>
																	<div className="fest-hover-desc">
																		<p className="festivalpg-paneltitle">
																			{object.name}
																		</p>
																		<div className="festivalpg-paneldescriptoin">
																			<ul className="panel-menu-list">
																				{ object.sub_menu ? (
																						object.sub_menu.map(function(object1, a){
																							return (<li key={a}><Link to={object1.url}>{object1.name}</Link></li>);
																						})
																					):('')
																				}
																				</ul>
																			</div>
																		</div>
																	</div>
																):(
																	<Link to={object.url}>
																		<div className="festivalpg-panelbox">
																			<span className="festival-hover-mask"></span>
																			<div className="fest-hover-desc">
																				<p className="festivalpg-paneltitle">
																					{object.name}
																				</p>
																				<div className="festivalpg-paneldescriptoin">
																					<ul className="panel-menu-list">
																						{ object.sub_menu ? (
														 										object.sub_menu.map(function(object1, a){
																									return (<li key={a}><Link to={object1.url}>{object1.name}</Link></li>);
																								})
																							):('')
																						}
																					</ul>
																				</div>
																			</div>
																		</div>
																	</Link>
																)
															}
													</div>
													);
										}

									})
							}


						</div>

					</div>
				</div>
			</div>
		);
		}else{
			return (
				<div className="BigMenu col-xs-12 col-ms-12 col-lg-12">
					<div className="row">
						<div className="gb-parentpanel-hoder" style={{height: this.state.length * 35 + 35}}>
							<div className="concurs-panels-holder panels-holder-desctopset">
								<div className="festivalpg-panelholder-mask" style={{backgroundColor: "#"+this.state.config.gbcolor}}></div>

									{this.state.data.boxes.map(function(object, i){

										if(typeof object.sub_menu !== "undefined" && object.sub_menu.constructor === Array){
											return (
													<div className="festivalpg-panelholder" key={object.id} style={{borderColor: object.color, height: object.sub_menu.length * 35 + 35}}>
															{ object.sub_menu ? (
																<div className="festivalpg-panelbox">
																	<span className="festival-hover-mask"></span>
																	<div className="fest-hover-desc">
																		<p className="festivalpg-paneltitle">
																			{object.name}
																		</p>
																		<div className="festivalpg-paneldescriptoin">
																			<ul className="panel-menu-list">
																				{ object.sub_menu ? (
																						object.sub_menu.map(function(object1, a){
																							return (<li key={a}><Link to={object1.url}>{object1.name}</Link></li>);
																						})
																					):('')
																				}
																				</ul>
																			</div>
																		</div>
																	</div>
																):(
																	<Link to={object.url}>
																		<div className="festivalpg-panelbox">
																			<span className="festival-hover-mask"></span>
																			<div className="fest-hover-desc">
																				<p className="festivalpg-paneltitle">
																					{object.name}
																				</p>
																				<div className="festivalpg-paneldescriptoin">
																					<ul className="panel-menu-list">
																						{ object.sub_menu ? (
														 										object.sub_menu.map(function(object1, a){
																									return (<li key={a}><Link to={object1.url}>{object1.name}</Link></li>);
																								})
																							):('')
																						}
																					</ul>
																				</div>
																			</div>
																		</div>
																	</Link>
																)
															}
													</div>
													);
										}else{
											return (
													<div className="festivalpg-panelholder" key={object.id} style={{borderColor: object.color}}>
															{ object.sub_menu ? (
																<div className="festivalpg-panelbox">
																	<span className="festival-hover-mask"></span>
																	<div className="fest-hover-desc">
																		<p className="festivalpg-paneltitle">
																			{object.name}
																		</p>
																		<div className="festivalpg-paneldescriptoin">
																			<ul className="panel-menu-list">
																				{ object.sub_menu ? (
																						object.sub_menu.map(function(object1, a){
																							return (<li key={a}><Link to={object1.url}>{object1.name}</Link></li>);
																						})
																					):('')
																				}
																				</ul>
																			</div>
																		</div>
																	</div>
																):(
																	<Link to={object.url}>
																		<div className="festivalpg-panelbox">
																			<span className="festival-hover-mask"></span>
																			<div className="fest-hover-desc">
																				<p className="festivalpg-paneltitle">
																					{object.name}
																				</p>
																				<div className="festivalpg-paneldescriptoin">
																					<ul className="panel-menu-list">
																						{ object.sub_menu ? (
														 										object.sub_menu.map(function(object1, a){
																									return (<li key={a}><Link to={object1.url}>{object1.name}</Link></li>);
																								})
																							):('')
																						}
																					</ul>
																				</div>
																			</div>
																		</div>
																	</Link>
																)
															}
													</div>
													);
										}

									})
							}


						</div>

					</div>
				</div>
			</div>
		);

	}
}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/BigMenu/BigMenu.js